import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';
import type { Language } from '../../language';
import { webTransition } from '../web-transition';

export interface DesktopLanguageOptionProps {
  isSelected: boolean;
  lang: Language;
  onPress: () => void;
}

export function DesktopLanguageOption({ isSelected, lang, onPress }: DesktopLanguageOptionProps) {
  return (
    <Button
      minWidth={36}
      paddingHorizontal="spacing.general.x1"
      paddingVertical="spacing.general.x0,5"
      onPress={onPress}
      style={[
        {
          borderColor: 'rgba(0, 0, 0, 0.12)',
          borderRadius: 12,
          borderWidth: 1,
          ...webTransition('background-color 140ms ease, border-color 140ms ease'),
        },
        isSelected ? { backgroundColor: 'rgba(0, 0, 0, 0.055)', borderColor: 'rgba(0, 0, 0, 0.16)' } : undefined,
      ]}
    >
      <Text color="text.primary" fontSize={12} fontWeight="700">
        {lang.toUpperCase()}
      </Text>
    </Button>
  );
}
